import { QcStatusEnum } from '@dynamika-shared/types/status';
import { faker } from '@faker-js/faker';
import { mockPaginate } from './paginate';

export const qcData = [
  {
    id: 1,
    studyId: '1.2.392.200036.9125.2.152544498129.6532632789.208030',
    site: 'SITE_01',
    name: 'K&L',
    visit: 'Baseline',
    scanDate: faker.date.past().getTime(),
    uploadDate: faker.date.past().getTime(),
    qcStatus: QcStatusEnum.PENDING,
    mode: 'image-viewer',
    subject: 'MRN_0002141',
    qcCheckDate: faker.date.past().getTime(),
    dueDate: faker.date.recent().getTime(),
    imagingSpecialist: faker.person.fullName(),
    birthDate: faker.date.past().getTime(),
  },
  {
    id: 2,
    studyId: '1.3.76.13.105976.2.20211116144320.976992.1',
    site: 'SITE_02',
    name: 'Advanced Analysis',
    visit: 'Visit 1',
    scanDate: faker.date.past().getTime(),
    uploadDate: faker.date.past().getTime(),
    qcStatus: QcStatusEnum.ON_HOLD,
    mode: 'segmentation',
    subject: 'MRN_0101614',
    qcCheckDate: faker.date.past().getTime(),
    dueDate: faker.date.recent().getTime(),
    birthDate: faker.date.past().getTime(),
  },
  {
    id: 3,
    studyId: '1.2.528.1.1001.100.2.437.19229.1902515551.20221128231229082',
    site: 'SITE_03',
    name: 'RECIST 1.1',
    visit: 'C1 D1',
    scanDate: faker.date.past().getTime(),
    uploadDate: faker.date.past().getTime(),
    qcStatus: QcStatusEnum.QUERY_OPEN,
    mode: 'image-viewer',
    subject: 'MRN_010143',
    dueDate: faker.date.recent().getTime(),
    imagingSpecialist: faker.person.fullName(),
    birthDate: faker.date.past().getTime(),
  },
  {
    id: 4,
    studyId: '1.2.826.0.1.6286687.99.1.254742133245301742031452713717769111769',
    site: 'SITE_04',
    name: 'DEMRIQ',
    visit: 'Baseline',
    scanDate: faker.date.past().getTime(),
    uploadDate: faker.date.past().getTime(),
    qcStatus: QcStatusEnum.IN_PROGRESS,
    mode: 'image-viewer',
    subject: 'MRN_0002140',
    qcCheckDate: faker.date.past().getTime(),
    imagingSpecialist: faker.person.fullName(),
    birthDate: faker.date.past().getTime(),
  },
  {
    id: 5,
    studyId: '1104.15.1202.1141.138.18.20210721120052.56',
    site: 'SITE_05',
    name: 'K&L',
    visit: 'Screening',
    scanDate: faker.date.past().getTime(),
    uploadDate: faker.date.past().getTime(),
    qcStatus: QcStatusEnum.PENDING,
    mode: 'image-viewer',
    subject: 'MRN_0101214',
    qcCheckDate: faker.date.past().getTime(),
    dueDate: faker.date.recent().getTime(),
    imagingSpecialist: faker.person.fullName(),
    birthDate: faker.date.past().getTime(),
  },
  {
    id: 6,
    studyId: '1.2.276.0.26.1.1.1.2.2020.349.41496.7337846',
    site: 'SITE_06',
    name: 'CLARA',
    visit: 'Baseline',
    scanDate: faker.date.past().getTime(),
    uploadDate: faker.date.past().getTime(),
    qcStatus: QcStatusEnum.FAILED,
    mode: 'image-viewer',
    subject: 'MRN_0102011',
    qcCheckDate: faker.date.past().getTime(),
    dueDate: faker.date.recent().getTime(),
    imagingSpecialist: faker.person.fullName(),
    birthDate: faker.date.past().getTime(),
  },
  {
    id: 7,
    studyId: '1.2.392.200036.9125.2.152544498129.6532632789.208030',
    series: ['1.2.392.200036.9125.3.152544498129.6532632790.208031'],
    site: 'SITE_00',
    name: 'MULTIPLE STUDIES',
    visit: 'Baseline',
    scanDate: faker.date.past().getTime(),
    uploadDate: faker.date.past().getTime(),
    qcStatus: QcStatusEnum.DONE,
    mode: 'image-viewer',
    subject: 'MRN_0002140',
    studies: [
      {
        id: '1.2.826.0.1.6286687.99.1.254742133245301742031452713717769111769',
      },
    ],
    qcCheckDate: faker.date.past().getTime(),
    dueDate: faker.date.recent().getTime(),
    imagingSpecialist: faker.person.fullName(),
    birthDate: faker.date.past().getTime(),
  },
];

export const createPaginatedQCList = (args: { page: number; size: number }) =>
  mockPaginate(qcData, args);
